<template>
  <a-row type="flex" :gutter="16">
    
    <a-col :md="24" :sm="24">
      <user-phone-bind v-model="currentOrgCode"/>
    </a-col>
  </a-row>
</template>

<script>
  import UserPhoneBind from './UserPhoneBind'

  export default {
    name: 'UserPhoneBindPart',
    components: { UserPhoneBind },
    data() {
      return {
        description: '通讯录页面',
        currentOrgCode: ''
      }
    },

    methods: {}
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>